<ul class="action-menu">
    <li>
        <a *ngIf="!marketplace_muted" (click)="mute()">{{ 'MARKETPLACE_MUTE_PARTICIPANT' | translate }}</a>
        <a *ngIf="marketplace_muted" (click)="unmute()">{{ 'MARKETPLACE_UNMUTE_PARTICIPANT' | translate }}</a>
    </li>
</ul>
